import { useHistory, useParams } from 'react-router';
import { QuirkIonPage } from '../components/QuirkIonPage.js';
import { QuirkIonContent } from '../components/QuirkIonContent.js';
import { Header } from '../components/Header.js';
import { IconButton } from '../components/IconButton.js';
import { IconClose, IconCheck } from '../components/QuirkIcons/index.js';
import { MarketplaceItemEditView } from '../components/PostTypeView/MarketplaceItemEditView.js';
import { useDeletePostMutation, useGetPostQuery, useUpdatePostMutation } from '../api/PostApi.js';
import { isMutationError } from '../util/error.js';
import { FullMarketplaceItem, FullPost, MarketplaceItem, objectEquals } from 'model';
import FormFooter from '../components/FormFooter.js';
import { MarketplaceItemEditRules } from '../formConfigs/MarketplaceItemFIeldsConfig.js';
import { useFormValues } from '../hooks/useFormValues.js';
import { useIonToast } from '@ionic/react';

export function EditMarketPlaceItem() {
	const [showToast] = useIonToast();
	const history = useHistory();
	const { postId } = useParams<{ postId: string }>();
	const [updatePost, { isLoading: updateIsLoading }] = useUpdatePostMutation();
	const { data: item } = useGetPostQuery(postId, { skip: postId === '' });
	const [deletePost, { isLoading: isDeleting }] = useDeletePostMutation();
	const onCancel = async () => {
		if (item !== undefined && item.draft === true) {
			const result = await deletePost(postId);
			if (!isMutationError(result)) {
				history.goBack();
			}
		} else {
			history.goBack();
		}
	};
	const { setValues, formValues, validateForm, stateDataObject, formSuccess } = useFormValues<MarketplaceItem>(
		MarketplaceItemEditRules,
		item as FullMarketplaceItem,
		objectEquals
	);
	const onSubmit = async () => {
		if (validateForm() && stateDataObject) {
			const result = await updatePost({
				post: {
					...item,
					...stateDataObject,
					draft: false
				} as FullPost
			});
			if (isMutationError(result)) {
				showToast({
					color: 'danger',
					position: 'top',
					message: `There was an error ${item?.draft === true ? 'creating' : 'updating'} your item for sale`,
					duration: 1500
				});
			} else {
				showToast({
					color: 'success',
					message: `Item for sale has been ${item?.draft === true ? 'created' : 'updated'}`,
					position: 'top',
					duration: 1500
				});
				history.goBack();
			}
		}
	};
	return (
		<QuirkIonPage name="Edit Item For Sale">
			<Header
				title="Sell Item"
				left={<IconButton icon={<IconClose />} onClick={onCancel} disabled={isDeleting} />}
				right={
					<IconButton
						fill="solid"
						label="Done"
						disabled={updateIsLoading || isDeleting || !formSuccess}
						icon={<IconCheck />}
						onClick={onSubmit}
						testId="editPostDoneButton"
					/>
				}
			/>
			<QuirkIonContent flush padding>
				<>
					{formValues !== undefined && item !== undefined && (
						<>
							<MarketplaceItemEditView
								formValues={formValues}
								item={item as FullMarketplaceItem}
								setValues={setValues}
							/>
							<FormFooter
								onCancel={onCancel}
								onSubmit={onSubmit}
								disableSubmit={updateIsLoading || isDeleting || !formSuccess}
							/>
						</>
					)}
				</>
			</QuirkIonContent>
		</QuirkIonPage>
	);
}
